export default "__VITE_ASSET__5G5A9JlJ__"